// extracted by mini-css-extract-plugin
export default {"p":"Text_p__8fVrL","button":"Text_button__Y24du"};